import {getAccessToken, getTenant} from "./jetms-interop"

function Upload(request) {
  const url = `${window.env.api}/applications/deliveryconfiguration/restaurant-pool-schedule`

  return fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + getAccessToken(),
      'Content-Type': 'application/json',
      'x-je-tenant': getTenant()
    },
    body: JSON.stringify(request)
  })
}

export default { Upload }



// WEBPACK FOOTER //
// ./src/api/restaurantpoolschedule.js